<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" viewBox="0 0 4175 3006">
      <rect id="Frame" x="0" y="0" width="4175" height="3006" />
      <clipPath id="clip-frame">
        <use xlink:href="#Frame"/>
      </clipPath>
      <image ref="scan" x="0" y ="0" width="2014" height="3006" :xlink:href="`${publicPath}scenes/expedition-a/main-a.jpg`" />
    </svg>
    <SceneDialogue
      ref="dialogue"
      :width="0.48"
      :bg="`transparent`"
      :fontSize="24"
      :styles="{color: `white`, textAlign: `left`, fontFamily: `Minion Pro`, lineHeight: `1.5em`}"
      :tx="0.975" :ty="0.5">
      One summer, a man named Ansel Hall sent all types of scientists to the
      area from Rainbow Bridge to Monument Valley, so they could study our
      land, our culture, our people. They lived right in Tsegi.
      <br><br>
      The scientists brought some food, but it wasn’t enough to last the summer,
      so they bartered for meat with Diné, Navajo People.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/expedition-a/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import SceneDialogue from "../SceneDialogue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  mounted() {
    const dialogue = this.$refs["dialogue"].$el
    const scan = this.$refs["scan"]
    TweenLite.set(scan, {opacity: 0})
    TweenLite.set(dialogue, {opacity: 0})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(scan, 1, {opacity: 1}))
    this.tl.add(TweenLite.to(dialogue, 1, {opacity: 1}))
  },
  methods: {
    enter() {this.tl.play()}
  },
  components: {
    SceneDialogue,
  }
}
</script>

<style lang="css" scoped>
.canvas image {
  /* transform: scale(1.1) translateX(-100px);
  transform-origin: calc(4175px / 2) calc(3006px / 2); */
}
</style>
